<div
  class="context-menu-trigger"
  [ngStyle]="menuRootStyle"
  [matMenuTriggerFor]="menu"
></div>
<mat-menu #menu="matMenu" (closed)="onMenuClosed()">
  @if ((isHandset$ | async) && archive()) {
    <button mat-menu-item disabled>{{ archive()!.name }}</button>
    <mat-divider></mat-divider>
  }
  <!-- Import Actions-->
  @if (hasAddNewDocumentPermissions()) {
    @if (isGseConnected$ | async) {
      <button mat-menu-item (click)="onClickScan()">
        <mat-icon>scanner</mat-icon>
        <span transloco="IMPORT_SCAN"></span>
      </button>
    }
    <button mat-menu-item (click)="onClickImport()">
      <mat-icon>archive</mat-icon>
      <span transloco="IMPORT"></span>
    </button>
    <button mat-menu-item (click)="onClickImportCSV()">
      <mat-icon>cloud_upload</mat-icon>
      <span transloco="IMPORT_CSV"></span>
    </button>
    <mat-divider></mat-divider>
  }
  @for (search of searches(); track search) {
    <button
      mat-menu-item
      [ngClass]="{ active: getIsActiveSearch(search.id) }"
      (click)="onClickSearch(search)"
    >
      <mat-icon>search</mat-icon>
      <span>{{ search.name }}</span>
    </button>
  }
  @if (!hasSearches()) {
    <div mat-menu-item>
      <span transloco="NO_SEARCHES_AVAILABLE"></span>
    </div>
  }
</mat-menu>
